export const TPA_EXPERIMENTS = {
  USE_BLOCKS_PLAN_LIST_WIDGET: 'specs.membership.UseBlocksPlanListWidget',
  USE_BLOCKS_PACKAGE_PICKER_PAGE: 'specs.membership.UseBlocksPackagePickerPage',
  INSTALL_SPLIT_PAGES: 'specs.membership.InstallSplitPages',
  SINGLE_PLAN_NEW_PRESETS_PANEL: 'specs.membership.SinglePlanNewPresetsPanel',
  FIX_STUDIO_BLOCKS_PLAN_CARD: 'specs.membership.FixStudioBlocksPlanCard',
  REMOVE_PLAN_LIST_MOBILE_PRESET: 'specs.membership.RemoveMobilePresetPlanCardList',
  ECOM_INTEGRATION_ENABLED: 'specs.membership.EcomIntegrationEnabled'
};
//# sourceMappingURL=tpa.js.map